// src/api/contactService.js

import api from "./api";

export const getContact = () => {
  return api.get("/contact");
};

export const getContactById = (id) => {
  return api.get(`/contact/${id}`);
};

export const createContact = (data) => {
  return api.post("/contact", data);
};

export const updateContact = (id, data) => {
  return api.put(`/contact/${id}`, data);
};

export const deleteContact = (id) => {
  return api.delete(`/contact/${id}`);
};